import clsx from 'clsx'

import type { RealtyType } from 'shared/api/kyrgyzstan/search'

import s from './styles.module.scss'

interface BestOffersFiltersProps {
  activeOptionId: number
  onOptionIdChange: (optionId: number) => void
  options: RealtyType[]
}

export const BestOffersFilters = ({
  activeOptionId,
  onOptionIdChange,
  options,
}: BestOffersFiltersProps) => {
  if (options.length === 0) {
    return null
  }

  return (
    <div className={clsx('container', s.filters)}>
      {options.map((option) => (
        <button
          key={option.id}
          className={clsx(
            s.filter,
            'medium-14',
            activeOptionId === option.id && s.filterActive,
          )}
          onClick={() => onOptionIdChange(option.id)}
        >
          {option.name}
        </button>
      ))}
    </div>
  )
}
